module.exports = __webpack_public_path__ + "static/refractory-schematic-a33580b860d88b8479733c01de1ecb18.svg";